// extracted by mini-css-extract-plugin
export default {"DragOverlay":"_DragOverlay--m7ZTl","Text":"_Text--A_WKy"};